var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogoProdottiWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.623,
    height: 24,
    viewBox: "0 0 22.623 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2141",
    "data-name": "Raggruppa 2141",
    transform: "translate(-1.211 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3254",
    "data-name": "Tracciato 3254",
    d: "M12.492,4A14.566,14.566,0,0,1,22.644,8.21c.121.114.181.171.191.257s-.036.165-.127.321L12.892,25.7c-.115.2-.173.3-.252.3s-.138-.1-.256-.293L2.342,9.019c-.093-.155-.14-.232-.131-.318s.068-.145.188-.261A14.7,14.7,0,0,1,12.492,4Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3255",
    "data-name": "Tracciato 3255",
    d: "M12.519,7a12.078,12.078,0,0,1,8.316,3.375c.123.113.184.169.194.256s-.036.165-.128.322L12.9,24.551c-.117.2-.175.3-.255.3s-.14-.1-.259-.293L4.191,11.139c-.095-.155-.142-.232-.133-.319s.07-.144.191-.26A12.185,12.185,0,0,1,12.519,7Z",
    transform: "translate(0 1.15)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1808",
    "data-name": "Raggruppa 1808",
    transform: "translate(7.726 10.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3256",
    "data-name": "Tracciato 3256",
    d: "M12,10.383c0,.764-.448,1.383-1,1.383s-1-.619-1-1.383S10.448,9,11,9,12,9.619,12,10.383Zm6,4.15c0,1.528-.9,2.767-2,2.767s-2-1.239-2-2.767.9-2.767,2-2.767S18,13.005,18,14.533ZM9,20.067c1.1,0,2-1.239,2-2.767s-.9-2.767-2-2.767S7,15.772,7,17.3,7.9,20.067,9,20.067Z",
    transform: "translate(-7 -9)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogoProdottiWhite);
export default __webpack_public_path__ + "static/media/catalogo-prodotti-white.fc3cbeeb8e90a584717d95e47810071a.svg";
export { ForwardRef as ReactComponent };